import { render, staticRenderFns } from "./AddExclusive.vue?vue&type=template&id=dd6fc284"
import script from "./AddExclusive.vue?vue&type=script&lang=js"
export * from "./AddExclusive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports